import * as Sentry from '@sentry/angular';
import { environment } from 'environments/environment';
import { redactAccessTokens } from './access-token-url';

// The DSN is a public client identifier, not a secret — safe to commit.
// https://docs.sentry.io/concepts/key-terms/dsn-explainer/
const SENTRY_DSN =
    'https://1552d77ff116a2d096c7e00762b459eb@o142060.ingest.us.sentry.io/4510982411386880';

export function initSentry(): void {
    if (!environment.sentryEnabled) {
        return;
    }

    Sentry.init({
        dsn: SENTRY_DSN,
        environment: environment.sentryEnvironment,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.1,
        // main.ts removes the login token from the URL before this runs.
        // These are a second line of defense if one still reaches Sentry.
        beforeBreadcrumb: (breadcrumb) => redactAccessTokens(breadcrumb),
        beforeSend: (event) => redactAccessTokens(event),
        beforeSendTransaction: (event) => redactAccessTokens(event)
    });
}
